import { CustomModal } from '../CustomModal';
import { Btn, Card } from '@ui';

export const EquipmentSection = ({ title, children }: { title: string; children: React.ReactNode }) => (
    <Card variant="card-lg" className="info-section">
        <div className="section-header-row">
            <h3>{title}</h3>
        </div>
        <div className="info-grid">{children}</div>
    </Card>
);

export const EquipmentInfoRow = ({
    label,
    value,
    className,
}: {
    label: string;
    value: string;
    className?: string;
}) => (
    <div className={['info-row', className].filter(Boolean).join(' ')}>
        <span className="info-label">{label}</span>
        <span className="info-value">{value}</span>
    </div>
);

export const EquipmentUnsavedExitModal = ({
    visible,
    onDismiss,
    onConfirmLeave,
}: {
    visible: boolean;
    onDismiss: () => void;
    onConfirmLeave: () => void;
}) => (
    <CustomModal
        visible={visible}
        onDismiss={onDismiss}
        header="Unsaved Changes"
        footer={
            <div className="modal-footer-actions">
                <Btn variant="secondary-outlined" buttonText="Cancel" buttonOnClick={onDismiss} />
                <Btn variant="warning" buttonText="Leave" buttonOnClick={onConfirmLeave} />
            </div>
        }
    >
        <p>You have unsaved changes. Are you sure you want to leave?</p>
    </CustomModal>
);
